import { render, staticRenderFns } from "./MindSoft.vue?vue&type=template&id=2050e903&"
import script from "./MindSoft.vue?vue&type=script&lang=js&"
export * from "./MindSoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports